import { compareDesc } from 'date-fns'
import { moment } from '../../i18n/dates'
import { ILicense, LicenseType } from '../../models/License'

export const calculateDays = (date: Date, startDate: Date = new Date()) => {
  const m = moment()
  const mUtc = m.utc

  const greaterDate = m.duration(+mUtc(date), 'ms').asDays()
  const lesserDate = m.duration(+mUtc(startDate), 'ms').asDays()

  return Math.floor(greaterDate - lesserDate)
}

const getDays = (licenses: ILicense[]) => {
  const web = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_WEB_ANDROID_IOS,
  )
  const android = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_WEB_ANDROID,
  )
  const ios = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_WEB_IOS,
  )
  const premiumRoom = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_ROOMS,
  )
  const premiumBasic = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_BASIC,
  )
  const premiumAssistent = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_ASSISTENT,
  )
  const premiumProfessional = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_PROFESSIONAL,
  )
  const premiumLite = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_LITE,
  )
  const premiumPlus = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_PLUS,
  )
  const premiumPro = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_PRO,
  )
  const premiumMax = licenses.find(
    license => license.licenseType === LicenseType.LICENSE_PREMIUM_MAX
    ,
  )

  const dates = [
    web ? web.rawDate : null,
    android ? android.rawDate : null,
    ios ? ios.rawDate : null,
    premiumRoom ? premiumRoom.rawDate : null,
    premiumBasic ? premiumBasic.rawDate : null,
    premiumAssistent ? premiumAssistent.rawDate : null,
    premiumProfessional ? premiumProfessional.rawDate : null,
    premiumLite ? premiumLite.rawDate : null,
    premiumPlus ? premiumPlus.rawDate : null,
    premiumPro ? premiumPro.rawDate : null,
    premiumMax ? premiumMax.rawDate : null,
  ].sort(compareDesc)

  return calculateDays(dates[0] ? dates[0] : new Date())
}

export default getDays
